module.exports = __webpack_public_path__ + "static/img/beiantubiao.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beiantubiao.png
// module id = yBIC
// module chunks = 1